import {createI18n} from 'vue-i18n';
import localeMessages from '@/vue-i18n-locales.generated';
import formKitTheme from '@/formkitTheme';
import {createAutoAnimatePlugin} from '@formkit/addons';
import {de, nl} from '@formkit/i18n';
import {generateClasses} from '@formkit/themes';
import {defaultConfig as FKdc} from '@formkit/vue';

/**
 * Locale-dependent plugin configuration, shared by the client and SSR entrypoints. Configuring
 * these separately let numberFormats drift out of ssr.js, so $n() rendered differently on the
 * server than after hydration.
 */
const numberFormats = {
    currency: {
        style: 'currency',
        currency: 'EUR',
    },
    percent: {
        style: 'percent',
        useGrouping: true,
    },
};

const formKitLocales = {nl, de};

export function createLocaleI18n(locale, mainLocale) {
    return createI18n({
        legacy: false,
        locale,
        fallbackLocale: mainLocale,
        messages: localeMessages,
        numberFormats: Object.fromEntries(Object.keys(localeMessages).map((available) => [available, numberFormats])),
    });
}

export function createFormKitConfig(locale, extraConfig = {}) {
    return FKdc({
        config: {
            classes: generateClasses(formKitTheme),
        },
        plugins: [createAutoAnimatePlugin({duration: 150})],
        locales: formKitLocales,
        locale,
        globalInjection: true,
        ...extraConfig,
    });
}
